/* @flow */

import React from 'react';
import { withRouter } from 'react-router-dom';
import { onSubmitActions } from 'redux-form-submit-saga';
import { Segment, Button } from 'semantic-ui-react';
import { SAVE_PAGE } from 'catalog/actions/pages';
import CreatePageForm from 'catalog/screens/shared/components/CreatePageForm';

type Props = {
  history: Object,
};

const appendRedirectToFormData = data => ({
  ...data,
  redirectOnCreate: true,
});

const Create = ({ history, save }: Props) => {
  const cancel = (evt: SyntheticEvent) => {
    evt.preventDefault();
    history.goBack();
  };

  return (
    <CreatePageForm
      onSubmit={onSubmitActions(SAVE_PAGE, appendRedirectToFormData)}
    >
      {({ fields, submitting, pristine }) => (
        <div>
          <Segment>
            <Button
              content="Retour à la liste"
              disabled={submitting}
              onClick={cancel}
              basic
              icon="chevron circle left"
              labelPosition="left"
            />
            <Button
              content="Enregistrer"
              disabled={pristine}
              loading={submitting}
              primary
              floated="right"
              icon="save"
              labelPosition="left"
            />
          </Segment>
          <Segment children={fields} />
        </div>
      )}
    </CreatePageForm>
  );
};

export default withRouter(Create);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Page/Create/index.js